import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { NotificationsService } from 'src/app/notifications/notifications.service';

@Component({
  selector: 'app-mailing-to-detail',
  templateUrl: './mailing-to-detail.component.html',
  styleUrls: ['./mailing-to-detail.component.scss']
})
export class MailingToDetailComponent implements OnInit {
  public notificationTo: any = {};
  public notificationStats: any[] = [];

  constructor(
    private notificationsService: NotificationsService,
    private dynamicDialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) { }

  ngOnInit(): void {
    this.loadNotificationTo(this.config.data.notification_to_id);
    this.loadNotificationStats(this.config.data.notification_to_id);
  }

  loadNotificationTo(id: number) {
    if (id) {
      this.notificationsService.getNotificationTo(id).subscribe(
        data => {
          this.notificationTo = data;
        },
        error => {
          //TODO message
        }
      );
    }
  }

  loadNotificationStats(id: number) {
    if (id) {
      this.notificationsService.allNotificationsStats({ notification_to_id: id }).subscribe(
        data => {
          this.notificationStats = data.rows;
        },
        error => {
          //TODO message
        }
      );
    }
  }

  getState(status) {
    if (status == 'sent') {
      return "<div class='badge badge-block badge-success'>Enviado</div>";
    } else if (status == "pending") {
      return "<div class='badge badge-block badge-warning'>Pendiente</div>";
    } else if (status == "programmed") {
      return "<div class='badge badge-block badge-info'>Programado</div>";
    } else if (status == "error") {
      return "<div class='badge badge-block badge-danger'>Error</div>";
    } else {
      return "<div class='badge badge-block badge-secondary'>Pendientes</div>";
    }

  }
}
